import React from "react";
import { Map, GoogleApiWrapper, Marker, Circle } from "google-maps-react";

const GoogleMapRadius = ({ google, latitude, longitude, cartType, zoom}) => {
  var bounds = google.maps.LatLngBounds();
  return (
      <>
        <div
            style={{
              width: "100%",
              paddingTop: "10px",
              marginBottom: "10px",
              height: "70vh",
              position: "relative"
            }}
        >
          <Map
              streetViewControl={false}
              mapTypeControl={false}
              keyboardShortcuts={false}
              scrollwheel={false}
              center={{ lat: latitude, lng: longitude }}
              google={google}
              bounds={bounds}
              style={{
                width: "100%",
                height: "70vh",
              }}
              zoom={zoom}
              initialCenter={{ lat: latitude, lng: longitude}}
              fullscreenControl={false}
          >
            {
              cartType === "express"?
                  <Circle
                      key={3}
                      radius={4000}
                      center={{ lat: latitude, lng: longitude }}
                      strokeColor='green'
                      strokeOpacity={0.5}
                      strokeWeight={1}
                      fillColor='green'
                      fillOpacity={0.1}
                  />:
                  [
                    <Circle
                        key={1}
                        radius={17000}
                        center={{ lat: latitude, lng: longitude }}
                        strokeColor='red'
                        strokeOpacity={0.5}
                        strokeWeight={1}
                        fillColor='red'
                        fillOpacity={0.1}
                    />,
                    <Circle
                        key={2}
                        radius={5000}
                        center={{ lat: latitude, lng: longitude }}
                        strokeColor='green'
                        strokeOpacity={0.5}
                        strokeWeight={1}
                        fillColor='green'
                        fillOpacity={0.2}
                    />
                  ]
            }
          </Map>
        </div>
      </>
  );
};

export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
})(GoogleMapRadius);
